import React from "react";
import { Btn } from "@app/shared/src/components_v2";

/**
 * The sticky commit bar for a settings section.
 *
 * Settings here are typed and picked, not toggled-and-saved: a half-entered speed is not something
 * to push to a truck, so edits stay local until someone commits them. That makes an explicit,
 * always-visible Discard just as important as Save — it is the only way back from a change made by
 * accident on the wrong unit.
 */
export const SaveBar: React.FC<{
    show: boolean;
    busy?: boolean;
    /** Blocks Save while the draft holds something that cannot be written. */
    canSave?: boolean;
    label?: string;
    onSave: () => void;
    onDiscard: () => void;
}> = ({ show, busy = false, canSave = true, label = "Unsaved changes", onSave, onDiscard }) => {
    if (!show) return null;

    return (
        <div className="fixed bottom-7 right-7 z-40 flex items-center gap-2.5 rounded-[16px] border border-[var(--line-2)] bg-[var(--surface)] p-3 shadow-[0_20px_50px_rgba(0,0,0,.45)] max-[700px]:inset-x-4 max-[700px]:bottom-4 max-[700px]:right-4">
            <span className="pl-2 pr-1 text-[13.5px] text-[var(--muted)]">{label}</span>
            <Btn tone="danger" onClick={onDiscard} disabled={busy}>
                Discard
            </Btn>
            <Btn onClick={onSave} disabled={busy || !canSave}>
                {busy ? "Saving…" : "Save changes"}
            </Btn>
        </div>
    );
};
